/**
 * The one look every project tile wears, wherever project cards are rendered
 * (the building dashboard's grid — active and archived — and the PM pages'
 * zero-projects create card), and the building cards on My buildings: the same white card as `DashboardPanel` — a
 * near-invisible hairline and a soft lift — sitting directly on the white page.
 */

const TILE_BASE = "rounded-[12px] p-3";

/** Fixed tile height, so names and stat rows share a baseline across the grid.
 *  Sized to the content (name line + optional description + stat row) with no
 *  slack, so a tile never opens a dead gap between its title and its stats. */
export const PROJECT_TILE_HEIGHT_CLASS = "h-[80px]";

/** Left padding that lines text up with the tile's title *text* — i.e. past the
 *  leading folder icon (h-5 = 1.25rem) and its gap-2 (0.5rem). Description and
 *  stat rows wear it so title, description and stats share one vertical line. */
export const PROJECT_TILE_TEXT_INDENT_CLASS = "pl-7";

/** White surface + hairline + soft lift — the dashboard card look. */
export const PROJECT_TILE_SURFACE_CLASS = "border border-black/[0.06] bg-white shadow-lift";

/** A project's own tile. Pair with `PROJECT_TILE_INTERACTIVE_CLASS` when it is clickable. */
export const PROJECT_TILE_CLASS = `flex flex-col ${TILE_BASE} ${PROJECT_TILE_SURFACE_CLASS}`;

/** Hover lifts the tile a step further rather than tinting it. */
export const PROJECT_TILE_INTERACTIVE_CLASS =
  "cursor-pointer transition-[box-shadow,border-color] hover:border-black/[0.08] hover:shadow-lift-hover";

/** The [+ New project] variant: dashed grey outline on white, grey text.
 *  Height is the caller's call — the grid matches the project tiles, the PM
 *  empty state stands taller. */
export const PROJECT_TILE_DASHED_CLASS = `flex cursor-pointer flex-col items-center justify-center gap-2 ${TILE_BASE} border border-dashed border-[#d8d8da] text-center text-muted-foreground transition-colors hover:border-primary hover:text-primary`;
